import axios from "axios";
import { format } from "date-fns";
import React, { Component } from "react";
import MerchantReportsFilter from "./MerchantReportsFilter";
import MerchantReport from "./components/merchantReport";

const online_scope_reports = [
  {
    name: "Merchant performance report",
    url: `/api/reports/merchant/trn-report`,
    filename: "merchant_performance_report",
    file_type: "zip",
    userTypes: [
      "bkash-super-user",
      "area_manager",
      "regional_manager",
      "territory_manager",
      "agency_user",
    ],
    filenamePatterns: ["report_type", "transaction_date"],
  },
  {
    name: "Merchant agency report",
    url: `/api/reports/merchant/agency-report`,
    filename: "merchant_agency_report",
    file_type: "zip",
    userTypes: ["bkash-super-user"],
  },
  // {
  //   name: "Merchant categorization file",
  //   url: `/api/reports/merchant/categorization-report`,
  //   filename: "merchant_categorization_file",
  //   file_type: "zip",
  //   userTypes: ["bkash-super-user"],
  // },
];

export default class MerchantReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: null,
      fetchingFileName: "",
      user_type: JSON.parse(localStorage.getItem("currUserType")),
    };
  }

  filteUserTypePermission = (i) => {
    const user_type = this.state.user_type;
    var filterPass = false;
    if (!i.userTypes) return true;
    if (i.userTypes)
      i.userTypes.map((userType) => {
        if (userType === user_type) filterPass = true;
      });
    return filterPass;
  };

  generatePostBody = (item) => {
    const filter = { ...this.state.filter };
    const status = filter["status"].value;
    const reg_start_date =
      filter["reg_start_date"].value === ""
        ? ""
        : format(new Date(filter["reg_start_date"].value), "yyyy-MM-dd");
    const reg_end_date =
      filter["reg_end_date"].value === ""
        ? ""
        : format(new Date(filter["reg_end_date"].value), "yyyy-MM-dd");

    if (item.filename === "merchant_categorization_file") {
      // if (!reg_start_date || !reg_end_date) {
      //   alert("Please select registration start and end date");
      //   return null;
      // }

      return {
        status,
        reg_start_date,
        reg_end_date,
      };
    }

    const report_type = filter["report_type"].value;
    const transaction_date =
      filter["transaction_date"].value === ""
        ? ""
        : format(new Date(filter["transaction_date"].value), "yyyy-MM-dd");

    if (!report_type || !transaction_date) {
      alert("Please select report type and transaction date");
      return null;
    }

    return {
      report_type,
      transaction_date,
      status,
      reg_start_date,
      reg_end_date,
      region: filter["regions"].value,
      territory: filter["territories"].value,

      area: filter["areas"].value,
      agency: filter["agency"].value,
      field_force: filter["field_force"].value,
      wallet_no: "",
    };
  };

  generateReportName = (item, body) => {
    var name = item.filename;
    //console.log(body);
    if (item.filenamePatterns) {
      item.filenamePatterns.map((pattern) => {
        name += `-${body[pattern]}`;
      });
      name += `-Downloaded at ${format(new Date(), "yyyy-MM-dd")}`;
    } else
      name = `${item.filename}-Downloaded at ${format(
        new Date(),
        "yyyy-MM-dd"
      )}`;
    name += `.${item.file_type}`;

    return name;
  };

  download = (item) => {
    const body = this.generatePostBody(item);
    if (body === null) {
      return;
    }
    const reportName = this.generateReportName(item, body);
    this.setState({ fetchingFileName: item.filename });
    axios
      .post(
        `${process.env.REACT_APP_API_URL}${item.url}`,
        {
          ...body,
        },

        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
          responseType: "blob",
        }
      )
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", reportName);
        document.body.appendChild(link);
        link.click();
      })
      .then(() => this.setState({ fetchingFileName: "" }))
      .catch((err) => {
        this.setState({ fetchingFileName: "" });
        alert(
          "Something went wrong ! Please contact your administrator for details. "
        );
      });
  };

  render() {
    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ width: "75%" }}>
          <div className="card-row row">
            {online_scope_reports
              .filter(this.filteUserTypePermission)
              .map((item, index) => (
                <div key={index} className="card-col col l4 m6 s12">
                  <MerchantReport
                    isCompactView={false}
                    report={item}
                    callBack={() => this.download(item)}
                    fetching={item.filename === this.state.fetchingFileName}
                  />
                </div>
              ))}
          </div>
        </div>

        <MerchantReportsFilter callBack={(f) => this.setState({ filter: f })} />
      </div>
    );
  }
}
